import { AgentsProvider } from './AgentsContext';

const AgentsProviderWrapper = ({ children }) => (
  <AgentsProvider>{children}</AgentsProvider>
);

export default AgentsProviderWrapper;
